// @flow
import { CopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import { ShareButtons } from '@ta-interaktiv/react-share-buttons'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import { VerticalSegment } from 'components/verticalSegment'
import React from 'react'
import './styles.scss'

interface IFooter {
  articleId: string
  publicationDate: number
}

export function Footer({ articleId, publicationDate }: IFooter) {
  return (
    <VerticalSegment className='relaxed grey secondary infographic ta footer'>
      <div className='ui two column stackable grid'>
        <div className='centered row portfolio'>
          <div className='column'>
            <a href='https://interaktiv.tagesanzeiger.ch'>
              <img
                alt='Die besten Arbeiten des Interaktiv-Teams'
                src='https://interaktiv.tagesanzeiger.ch/inline-teaser.gif'
                className='portfolio-teaser ui fluid image'
              />
            </a>
          </div>
        </div>

        <div className='row credits'>
          <div className='column'>
            <table className='ui small basic definition infographic table top aligned'>
              <tbody>
                <tr className={'top aligned'}>
                  <td>Interaktives Konzept und Programmierung</td>
                  <td>
                    Kaspar Manz, Edgar Schuler, Marc Brupbacher und Andreas
                    Moor, Interaktiv-Team
                  </td>
                </tr>
                <tr className={'top aligned'}>
                  <td>Text und Methodik</td>
                  <td>
                    Christian Fichter, Michael Dantlgraber und Stefan Ryf von
                    der Kalaidos Fachhochschule
                  </td>
                </tr>
                <tr>
                  <td>Veröffentlicht</td>
                  <td>
                    <TimestampFormatter timestamp={publicationDate} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className='column'>
            <FeedbackMessage />

            <ShareButtons
              displayType={'vertical buttons'}
              className={'basic purple'}
              articleId={articleId}
            />
          </div>
        </div>

        <div className='centered row copyright'>
          <div className='center aligned column'>
            <CopyrightNotice />
          </div>
        </div>
      </div>
    </VerticalSegment>
  )
}
